import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import UpdateUserStatusRequest from '../../../projects/performers/i-service/model/request/UpdateUserStatusRequest';
import UpdateUserEmailRequest from '../../../projects/performers/i-service/model/request/UpdateUserEmailRequest';
import UpdateUserFirstNameRequest from '../../../projects/performers/i-service/model/request/UpdateUserFirstNameRequest';
import UpdateUserLastNameRequest from '../../../projects/performers/i-service/model/request/UpdateUserLastNameRequest';
import UpdateUserMiddleNameRequest from '../../../projects/performers/i-service/model/request/UpdateUserMiddleNameRequest';
import UpdateUserDateOfBrithRequest from '../../../projects/performers/i-service/model/request/UpdateUserDateOfBrithRequest';
import UpdateUserFotoRequest from '../../../projects/performers/i-service/model/request/UpdateUserFotoRequest';
import CreateUserRequest from '../../../users/base/i-service/models/requests/CreateUserRequest';
import GetInviteTokenRequest from '../../../users/base/i-service/models/requests/GetInviteTokenRequest';
import GenerateUserInviteTokenRequest from '../../../users/base/i-service/models/requests/GenerateUserInviteTokenRequest';
import InviteUserRequest from '../../../users/base/i-service/models/requests/InviteUserRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import BaseResponse from '../../../tirscript/common/response-models/BaseResponse';
import CreateUserResponse from '../../../users/base/i-service/models/responses/CreateUserResponse';
import GetInviteTokenResponse from '../../../users/base/i-service/models/responses/GetInviteTokenResponse';
import GenerateUserInviteTokenResponse from '../../../users/base/i-service/models/responses/GenerateUserInviteTokenResponse';

export default class PerformersSaveService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	UpdateUserStatusEvent = new Events<WsResponseModelT<BaseResponse>>();
	UpdateUserEmailEvent = new Events<WsResponseModelT<BaseResponse>>();
	UpdateUserFirstNameEvent = new Events<WsResponseModelT<BaseResponse>>();
	UpdateUserLastNameEvent = new Events<WsResponseModelT<BaseResponse>>();
	UpdateUserMiddleNameEvent = new Events<WsResponseModelT<BaseResponse>>();
	UpdateUserDateOfBrithEvent = new Events<WsResponseModelT<BaseResponse>>();
	UpdateUserFotoEvent = new Events<WsResponseModelT<BaseResponse>>();
	CreateUserEvent = new Events<WsResponseModelT<CreateUserResponse>>();
	GetInviteTokenEvent = new Events<WsResponseModelT<GetInviteTokenResponse>>();
	GenerateUserInviteTokenEvent = new Events<WsResponseModelT<GenerateUserInviteTokenResponse>>();
	InviteUserEvent = new Events<WsResponseModelT<BaseResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('PerformersSaveService', 'UpdateUserStatus', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserStatusEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'UpdateUserEmail', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserEmailEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'UpdateUserFirstName', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserFirstNameEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'UpdateUserLastName', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserLastNameEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'UpdateUserMiddleName', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserMiddleNameEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'UpdateUserDateOfBrith', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserDateOfBrithEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'UpdateUserFoto', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserFotoEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'CreateUser', 'Main', (res: WsResponseModelT<CreateUserResponse>) => {
			self.CreateUserEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'GetInviteToken', 'Main', (res: WsResponseModelT<GetInviteTokenResponse>) => {
			self.GetInviteTokenEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'GenerateUserInviteToken', 'Main', (res: WsResponseModelT<GenerateUserInviteTokenResponse>) => {
			self.GenerateUserInviteTokenEvent.trigger(res);
		});
		webApiService.on('PerformersSaveService', 'InviteUser', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.InviteUserEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Обновление статуса пользователя
	 */
	async UpdateUserStatus(request: UpdateUserStatusRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'UpdateUserStatus',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление почты пользователя
	 */
	async UpdateUserEmail(request: UpdateUserEmailRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'UpdateUserEmail',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление имени пользователя
	 */
	async UpdateUserFirstName(request: UpdateUserFirstNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'UpdateUserFirstName',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление фамилии пользователя
	 */
	async UpdateUserLastName(request: UpdateUserLastNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'UpdateUserLastName',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление отчества пользователя
	 */
	async UpdateUserMiddleName(request: UpdateUserMiddleNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'UpdateUserMiddleName',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление даты рождения пользователя
	 */
	async UpdateUserDateOfBrith(request: UpdateUserDateOfBrithRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'UpdateUserDateOfBrith',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление фото пользователя
	 */
	async UpdateUserFoto(request: UpdateUserFotoRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'UpdateUserFoto',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание пользователя
	 */
	async CreateUser(request: CreateUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'CreateUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение токена приглашения
	 */
	async GetInviteToken(request: GetInviteTokenRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'GetInviteToken',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Генерация токена приглашения
	 */
	async GenerateUserInviteToken(request: GenerateUserInviteTokenRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'GenerateUserInviteToken',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Пригласить пользователя
	 */
	async InviteUser(request: InviteUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PerformersSaveService',
			Method: 'InviteUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Обновление статуса пользователя
	 */
	async updateUserStatusAsync(request: UpdateUserStatusRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'UpdateUserStatus',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление почты пользователя
	 */
	async updateUserEmailAsync(request: UpdateUserEmailRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'UpdateUserEmail',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление имени пользователя
	 */
	async updateUserFirstNameAsync(request: UpdateUserFirstNameRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'UpdateUserFirstName',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление фамилии пользователя
	 */
	async updateUserLastNameAsync(request: UpdateUserLastNameRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'UpdateUserLastName',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление отчества пользователя
	 */
	async updateUserMiddleNameAsync(request: UpdateUserMiddleNameRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'UpdateUserMiddleName',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление даты рождения пользователя
	 */
	async updateUserDateOfBrithAsync(request: UpdateUserDateOfBrithRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'UpdateUserDateOfBrith',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление фото пользователя
	 */
	async updateUserFotoAsync(request: UpdateUserFotoRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'UpdateUserFoto',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание пользователя
	 */
	async createUserAsync(request: CreateUserRequest): Promise<CreateUserResponse> {
		return new Promise<CreateUserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'CreateUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<CreateUserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CreateUserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение токена приглашения
	 */
	async getInviteTokenAsync(request: GetInviteTokenRequest): Promise<GetInviteTokenResponse> {
		return new Promise<GetInviteTokenResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'GetInviteToken',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetInviteTokenResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetInviteTokenResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Генерация токена приглашения
	 */
	async generateUserInviteTokenAsync(request: GenerateUserInviteTokenRequest): Promise<GenerateUserInviteTokenResponse> {
		return new Promise<GenerateUserInviteTokenResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'GenerateUserInviteToken',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GenerateUserInviteTokenResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GenerateUserInviteTokenResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Пригласить пользователя
	 */
	async inviteUserAsync(request: InviteUserRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PerformersSaveService',
				Method: 'InviteUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}